import React from "react";
import "./baseCard.css";
import SVGIcon from "./SVGIcon.tsx";
import type { BaseCardProps } from './BaseCardTypes.ts';
import { getContainerStyles, darkenColor } from './BaseCardUtils.ts';

const BaseCard: React.FC<BaseCardProps> = ({
  highlight = false,
  color = "var(--color-light-gray)",
  children,
  className = "",
}) => {
  const containerStyles = getContainerStyles(highlight);
  const shapeColor = darkenColor(color);

  return (
    <div
      className={`baseCard-container ${highlight ? "baseCard-highlight" : ""} ${className}`}
      style={
        {
          "--base-card-color": color,
          "--base-card-shape-color": shapeColor,
          backgroundColor: color,
          ...containerStyles,
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
};

export { BaseCard, SVGIcon };
export * from './BaseCardTypes.ts';
export * from './BaseCardUtils.ts';